<div class="flex items-center justify-between pb-6 pt-1 gap-3">
  <div class="min-w-0 cursor-pointer" (click)="handlerClickOnUserGreeting($event)">
    <p class="text-grey-400 text-xs font-semibold capitalize leading-tight">
      {{ today | date: 'EEEE d MMMM' }}
    </p>
    @if (user && user.pseudo) {
      <p class="text-primary-title text-xl font-medium leading-snug"
        [innerHTML]="'home.header.greeting' | translate: {firstName: user.pseudo}"></p>
    }
    @if (!user || !user.pseudo) {
      <p class="text-primary-title text-xl font-medium leading-snug"
        [innerHTML]="'home.header.greeting-guest' | translate"></p>
    }
  </div>
  <div class="flex items-center gap-2 shrink-0">
    <div class="relative bg-primary-500 rounded-full p-2 active:bg-primary-800 cursor-pointer" (click)="handleBell($event)">
      <vw-bell-icon
        class="w-5 h-5 text-white stroke-1">
      </vw-bell-icon>
      @if (unreadCount > 0) {
        <span class="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] font-bold rounded-full min-w-[16px] h-4 flex items-center justify-center px-0.5">
          {{ unreadCount > 9 ? '9+' : unreadCount }}
        </span>
      }
    </div>
    <vw-book-icon (click)="handleGuide($event)"
      class="bg-primary-500 text-white text-sm stroke-1 rounded-full p-2 active:bg-primary-800">
    </vw-book-icon>
  </div>
</div>
